import { render, staticRenderFns } from "./addRolePage.vue?vue&type=template&id=8eb7c234&"
import script from "./addRolePage.vue?vue&type=script&lang=js&"
export * from "./addRolePage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports